<template>
  <div>
    <div class="flex-full row">
      <multi-selection-list
        caption="Campaign Names"
        :items="campaignNames"
        @add="addCampaign"
        @remove="removeCampaign"
      />
      <!-- <div
        v-if="!hideLock"
        :style="{
          backgroundColor: this.configCampaigns.locked
            ? 'rgb(216, 77, 77)'
            : '#74db7c',
        }"
        class="control-btn"
        @click="toggleLock"
      >
        <font-awesome-icon :icon="['fas', 'lock']" />
        <span class="tooltiptext">Locks list so it can't be changed.</span>
      </div> -->
    </div>
    <div
      style="margin-top: 10px"
      class="flex justify-end"
    >
      <input
        class="btn"
        type="button"
        style="margin-right: 5px"
        value="All"
        @click="selectAll()"
      />
      <input
        class="btn"
        type="button"
        style="margin-right: 5px"
        value="Inbound"
        @click="select('in')"
        v-if="type === 'all'"
      />
      <input
        type="button"
        value="Outbound"
        style="margin-right: 5px"
        @click="select('out')"
        v-if="type === 'all'"
        class="btn"
      />
      <input class="btn" type="button" value="Clear" @click="clear()" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      required: true,
      value: Object,
    },

    argType: {
      type: String,
      required: true,
    },

    type: {
      type: String,
      default: "all",
    },

    hideLock: {
      required: false,
      value: Boolean,
    },
  },
  mounted(){
    console.log(this.argType)
  },

  computed: {
    campaignNames() {
      return this.allCampaigns.map((x) => ({
        name: x.name,
        selected: this.items.includes(x.name),
      }));
    },

    allCampaigns() {
      return this.$diamond.allowedCampaigns.filter((x) =>
        this.type === "all" ? true : x.type === this.type
      );
    },
  },

  methods: {
    addCampaign(name) {
      this.$store.getters[this.argType].addCampaignName(name);
      this.items.push(name);
      this.$emit("selected", name);
    },

    removeCampaign(name) {
      var index = this.items.indexOf(name);
      this.$store.getters[this.argType].removeCampaignName(name);
      if (index !== -1) this.items.splice(index, 1);
      this.$emit("removed", name);
    },

    select(type) {
      this.allCampaigns
        .filter((x) => x.type == type && !this.items.includes(x.name))
        .forEach((x) => this.addCampaign(x.name));
    },

    clear() {
      let i = this.items.length;
      while(i--) {
        this.$store.getters[this.argType].removeCampaignName(this.items[i]);
        this.items.splice(i, 1);
        this.$emit("removed", this.items[i]);
      }
    },

    selectAll() {
      this.allCampaigns
        .filter((x) => !this.items.includes(x.name))
        .forEach((x) => this.addCampaign(x.name));
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
}

.justify-end {
  justify-content: flex-end;
}

.btn {
  font-family: "Roboto", sans-serif;
  text-transform: uppercase;
  outline: 0;
  background: #0186c9;
  border: 0;
  padding: 6px;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
}

.control-btn {
  border-radius: 6px;
  height: 36px;
  width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.3em;
  margin-right: 10px;
  position: relative;
  cursor: pointer;
  margin: 10px;
}

.control-btn .tooltiptext {
  visibility: hidden;
  min-width: 200px;
  background-color: #303030;
  color: #fff;
  text-align: center;
  padding: 5px;
  border-radius: 6px;
  font-size: 12pt;
  position: absolute;
  z-index: 1;
  top: 103%;
  left: 0;
}

.control-btn:hover .tooltiptext {
  visibility: visible;
}

.row {
  align-items: center;
}
</style>